(() => {
document.addEventListener('click', event => {
 const menuToggle = document.querySelector('.menu-toggle'), mobileMenu = document.querySelector('#mobile-menu');
 if (!menuToggle || !mobileMenu) return;
 const toggle = event.target.closest('.menu-toggle');
 if (!toggle && !event.target.closest('#mobile-menu a')) return;
 const open = toggle ? menuToggle.getAttribute('aria-expanded') !== 'true' : false;
 menuToggle.setAttribute('aria-expanded', String(open));
 menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
 mobileMenu.hidden = !open;
});

const controllers = new WeakMap();
function initialize(root) {
 if (!root.querySelector('#main-image')) return;
 controllers.get(root)?.abort();
 const controller = new AbortController();
 controllers.set(root, controller);
 const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal: controller.signal });
 const shots = [...root.querySelectorAll('[data-shot]')].map(button => ({
 src: button.dataset.imageSrc || button.querySelector('img').src,
 alt: button.getAttribute('aria-label'),
 position: button.querySelector('img').style.objectPosition || '50% 50%'
}));

const mainImage = root.querySelector('#main-image');
const mainShot = root.querySelector('.main-shot');
const thumbnails = root.querySelectorAll('[data-shot]');
let currentShot = 0;
thumbnails.forEach(button => listen(button, 'click', () => {
  const index = Number(button.dataset.shot);
  const shot = shots[index];
  currentShot = index;
  mainImage.src = shot.src;
  mainImage.alt = shot.alt;
  mainImage.style.objectPosition = shot.position;
  thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
}));

const lightbox = document.querySelector('#image-lightbox');
const lightboxImage = document.querySelector('#lightbox-image');
const lightboxCaption = document.querySelector('#lightbox-caption');
const lightboxStage = document.querySelector('[data-lightbox-stage]');
const zoomReadout = document.querySelector('#lightbox-zoom');
const zoomInButton = document.querySelector('[data-zoom-in]');
const zoomOutButton = document.querySelector('[data-zoom-out]');
const zoomResetButton = document.querySelector('[data-zoom-reset]');
const closeButtons = document.querySelectorAll('[data-lightbox-close]');
const activePointers = new Map();
let zoom = 1;
let panX = 0;
let panY = 0;
let dragStart = null;
let pinchStart = null;
let touchStart = null;

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function clampPan() {
  const rect = lightboxStage.getBoundingClientRect();
  const limitX = Math.max(0, rect.width * (zoom - 1) / 2);
  const limitY = Math.max(0, rect.height * (zoom - 1) / 2);
  panX = clamp(panX, -limitX, limitX);
  panY = clamp(panY, -limitY, limitY);
}

function renderLightbox() {
  clampPan();
  lightboxImage.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${zoom})`;
  zoomReadout.textContent = `${Math.round(zoom * 100)}%`;
  lightboxStage.classList.toggle('is-draggable', zoom > 1);
}

function setZoom(nextZoom) {
  zoom = clamp(nextZoom, 1, 4);
  if (zoom === 1) {
    panX = 0;
    panY = 0;
  }
  renderLightbox();
}

function resetLightboxView() {
  zoom = 1;
  panX = 0;
  panY = 0;
  renderLightbox();
}

function openLightbox(index = currentShot) {
  const shot = shots[index];
  currentShot = index;
  const productSurface = mainShot.closest('[data-product-style]');
  const isApparel = productSurface?.dataset.productStyle === 'apparel';
  lightbox.classList.toggle('is-apparel', isApparel);
  if (isApparel) {
    lightbox.style.setProperty('--apparel-backdrop-color', getComputedStyle(productSurface).getPropertyValue('--apparel-backdrop-color').trim() || '#9aa36c');
  } else {
    lightbox.style.removeProperty('--apparel-backdrop-color');
  }
  lightboxImage.src = shot.src;
  lightboxImage.alt = shot.alt;
  lightboxImage.style.objectPosition = shot.position;
  lightboxCaption.textContent = shot.alt;
  lightbox.hidden = false;
  document.body.classList.add('is-lightbox-open');
  resetLightboxView();
  zoomInButton.focus({ preventScroll: true });
}

function closeLightbox() {
  lightbox.hidden = true;
  document.body.classList.remove('is-lightbox-open');
  activePointers.clear();
  dragStart = null;
  pinchStart = null;
  touchStart = null;
  lightboxStage.classList.remove('is-dragging');
  mainShot.focus({ preventScroll: true });
}

function pointerDistance(points) {
  const [first, second] = points;
  return Math.hypot(first.clientX - second.clientX, first.clientY - second.clientY);
}

function touchDistance(touches) {
  const [first, second] = touches;
  return Math.hypot(first.clientX - second.clientX, first.clientY - second.clientY);
}

listen(mainShot, 'click', () => openLightbox(currentShot));
closeButtons.forEach(button => listen(button, 'click', closeLightbox));
listen(zoomInButton, 'click', () => setZoom(zoom + .5));
listen(zoomOutButton, 'click', () => setZoom(zoom - .5));
listen(zoomResetButton, 'click', resetLightboxView);

listen(document, 'keydown', event => {
  if (!lightbox.hidden && event.key === 'Escape') closeLightbox();
});

listen(lightboxStage, 'wheel', event => {
  event.preventDefault();
  const step = event.deltaY > 0 ? -.22 : .22;
  setZoom(zoom + step);
}, { passive: false });

listen(lightboxStage, 'pointerdown', event => {
  if (lightbox.hidden) return;
  lightboxStage.setPointerCapture(event.pointerId);
  activePointers.set(event.pointerId, event);
  if (activePointers.size === 2) {
    pinchStart = {
      distance: pointerDistance([...activePointers.values()]),
      zoom,
    };
    dragStart = null;
  } else if (zoom > 1) {
    dragStart = {
      x: event.clientX,
      y: event.clientY,
      panX,
      panY,
    };
    lightboxStage.classList.add('is-dragging');
  }
});

listen(lightboxStage, 'pointermove', event => {
  if (!activePointers.has(event.pointerId)) return;
  activePointers.set(event.pointerId, event);
  if (activePointers.size === 2 && pinchStart) {
    const distance = pointerDistance([...activePointers.values()]);
    setZoom(pinchStart.zoom * (distance / pinchStart.distance));
    return;
  }
  if (!dragStart || zoom === 1) return;
  panX = dragStart.panX + event.clientX - dragStart.x;
  panY = dragStart.panY + event.clientY - dragStart.y;
  renderLightbox();
});

function endLightboxPointer(event) {
  activePointers.delete(event.pointerId);
  if (activePointers.size < 2) pinchStart = null;
  if (activePointers.size === 0) {
    dragStart = null;
    lightboxStage.classList.remove('is-dragging');
  }
}

listen(lightboxStage, 'pointerup', endLightboxPointer);
listen(lightboxStage, 'pointercancel', endLightboxPointer);
listen(lightboxStage, 'touchstart', event => {
  if (lightbox.hidden) return;
  if (event.touches.length === 2) {
    touchStart = {
      mode: 'pinch',
      distance: touchDistance([...event.touches]),
      zoom,
    };
    lightboxStage.classList.remove('is-dragging');
    event.preventDefault();
  } else if (event.touches.length === 1 && zoom > 1) {
    const touch = event.touches[0];
    touchStart = {
      mode: 'drag',
      x: touch.clientX,
      y: touch.clientY,
      panX,
      panY,
    };
    lightboxStage.classList.add('is-dragging');
    event.preventDefault();
  }
}, { passive: false });
listen(lightboxStage, 'touchmove', event => {
  if (!touchStart) return;
  if (touchStart.mode === 'pinch' && event.touches.length === 2) {
    setZoom(touchStart.zoom * (touchDistance([...event.touches]) / touchStart.distance));
    event.preventDefault();
    return;
  }
  if (touchStart.mode === 'drag' && event.touches.length === 1 && zoom > 1) {
    const touch = event.touches[0];
    panX = touchStart.panX + touch.clientX - touchStart.x;
    panY = touchStart.panY + touch.clientY - touchStart.y;
    renderLightbox();
    event.preventDefault();
  }
}, { passive: false });
listen(lightboxStage, 'touchend', () => {
  touchStart = null;
  lightboxStage.classList.remove('is-dragging');
});
listen(lightboxStage, 'touchcancel', () => {
  touchStart = null;
  lightboxStage.classList.remove('is-dragging');
});
listen(window, 'resize', renderLightbox);

const details = root.querySelector('#details-toggle');
const specs = root.querySelector('#specs');
listen(details, 'click', () => {
  const open = details.getAttribute('aria-expanded') !== 'true';
  details.setAttribute('aria-expanded', String(open));
  specs.classList.toggle('is-closed', !open);
  specs.setAttribute('aria-hidden', String(!open));
  specs.inert = !open;
});

const mapToggle = root.querySelector('#map-toggle');
const price = root.querySelector('#price');
const purchaseButton = root.querySelector('#purchase-button');

const form = root.querySelector('.poster-product-form');
const variantSelect = form?.querySelector('[name="id"]');
const posterButton = root.querySelector('#poster-only');
const sizePanel = form?.querySelector('[data-size-panel]');
const sizeButtons = [...(sizePanel?.querySelectorAll('[data-size-variant]') || [])];
if (sizeButtons.length) {
 sizePanel.querySelector('.apparel-sizes').hidden = false;
 form.classList.add('has-size-buttons');
 sizeButtons.forEach(button => listen(button, 'click', () => {
  variantSelect.value = button.dataset.sizeVariant;
  variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
 }));
}
function renderCart() {
 if (!form) return;
 const selected = mapToggle.getAttribute('aria-pressed') === 'true';
 const option = variantSelect.selectedOptions[0];
 if (sizeButtons.length) {
  sizeButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeVariant === option.value)));
  sizePanel.querySelector('[data-selected-size]').textContent = 'Selected: ' + option.textContent.trim();
 }
 const bundlePrice = purchaseButton.dataset.bundlePrice || option.dataset.price;
 price.textContent = selected ? bundlePrice : option.dataset.price;
 purchaseButton.textContent = 'Purchase Bundle  ' + bundlePrice;
 purchaseButton.hidden = !selected;
 posterButton.hidden = selected;
 const physicalVariants = form.querySelector('[data-physical-variants]');
 if (physicalVariants) physicalVariants.hidden = selected || variantSelect.hidden;
 posterButton.disabled = option.dataset.available !== 'true';
 posterButton.textContent = posterButton.disabled ? posterButton.dataset.soldOutLabel : posterButton.dataset.purchaseLabel + '  ' + option.dataset.price;
}
listen(mapToggle, 'click', () => {
 mapToggle.setAttribute('aria-pressed', String(mapToggle.getAttribute('aria-pressed') !== 'true'));
 renderCart();
});
variantSelect?.addEventListener('change', renderCart);
renderCart();
 const tooltip = document.createElement('div');
 tooltip.className = 'detail-tooltip';
 tooltip.id = 'detail-tooltip-' + root.id;
 tooltip.setAttribute('role', 'tooltip');
 tooltip.hidden = true;
 const tipTitle = document.createElement('div'); tipTitle.className = 'detail-tooltip-title';
 const tipCategory = document.createElement('div'); tipCategory.className = 'detail-tooltip-category';
 const tipInfo = document.createElement('p'); tipInfo.className = 'detail-tooltip-info';
 tooltip.append(tipTitle, tipCategory, tipInfo);
 document.body.append(tooltip);
 controller.signal.addEventListener('abort', () => tooltip.remove(), { once: true });
 let activeTip = null;
 let hideTimer;
 let touchTip = false;
 let tappedTile = null;
 function hideTip() { tappedTile = null; clearTimeout(hideTimer); if (activeTip) activeTip.removeAttribute('aria-describedby'); activeTip = null; tooltip.hidden = true; }
 function placeTip() {
  if (!activeTip) return;
  const r = activeTip.getBoundingClientRect();
  const w = tooltip.offsetWidth, h = tooltip.offsetHeight;
  tooltip.style.left = Math.max(12, Math.min(window.innerWidth - w - 12, r.left + r.width / 2 - w / 2)) + 'px';
  tooltip.style.top = (r.top - h - 12 >= 8 ? r.top - h - 12 : r.bottom + 12) + 'px';
 }
 function showTip(tile) {
  clearTimeout(hideTimer);
  if (activeTip && activeTip !== tile) activeTip.removeAttribute('aria-describedby');
  activeTip = tile;
  tipTitle.textContent = tile.dataset.tipTitle;
  tipCategory.textContent = tile.dataset.tipCategory;
  tipInfo.textContent = tile.dataset.tipInfo;
  tile.setAttribute('aria-describedby', tooltip.id);
  tooltip.hidden = false; placeTip();
 }
 for (const tile of root.querySelectorAll('[data-tip-title]')) {
  let wasOpenOnPress = false;
  listen(tile, 'pointerdown', e => { wasOpenOnPress = tappedTile === tile; touchTip = e.pointerType === 'touch'; });
  listen(tile, 'pointerenter', e => { if (e.pointerType !== 'touch') showTip(tile); });
  listen(tile, 'pointerleave', () => { if (document.activeElement !== tile) hideTimer = setTimeout(hideTip, 120); });
  listen(tile, 'focus', () => showTip(tile));
  listen(tile, 'blur', e => { if (e.relatedTarget && !tooltip.contains(e.relatedTarget)) hideTip(); });
  listen(tile, 'click', () => { if (wasOpenOnPress) hideTip(); else { showTip(tile); tappedTile = tile; } wasOpenOnPress = false; });
  listen(tile, 'keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showTip(tile); } });
 }
 listen(tooltip, 'pointerenter', () => clearTimeout(hideTimer));
 listen(tooltip, 'pointerleave', hideTip);
 listen(document, 'pointerdown', e => { if (activeTip && !activeTip.contains(e.target) && !tooltip.contains(e.target)) hideTip(); });
 listen(document, 'keydown', e => { if (e.key === 'Escape') hideTip(); });
 listen(window, 'scroll', () => { if (touchTip) hideTip(); else placeTip(); }, { passive: true });
 listen(window, 'resize', placeTip);
 listen(document, 'keydown', event => {
  if (lightbox.hidden || event.key !== 'Tab') return;
  const controls = [...lightbox.querySelectorAll('button')];
  const first = controls[0], last = controls[controls.length - 1];
  if(event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  else if(!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
 });
}
document.querySelectorAll('.shopify-section').forEach(initialize);
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('shopify:section:unload', event => {
 controllers.get(event.target)?.abort();
 document.querySelector('#image-lightbox').hidden = true;
 document.body.classList.remove('is-lightbox-open');
});
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const canvas = document.querySelector('#dust');
const context = canvas.getContext('2d');
let width = 0, height = 0, motes = [], lastTick = 0;
function makeMote() {
  return {
    x: Math.random() * width,
    y: Math.random() * height,
    r: .4 + Math.random() * 1.5,
    a: .06 + Math.random() * .34,
    vx: (Math.random() - .5) * .11,
    vy: -.04 - Math.random() * .16,
    ph: Math.random() * Math.PI * 2,
    sp: .004 + Math.random() * .012,
    life: 0,
    max: 90 + Math.random() * 130
  };
}
function resizeDust() {
  width = canvas.clientWidth || window.innerWidth;
  height = canvas.clientHeight || window.innerHeight;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = Math.round(width * dpr);
  canvas.height = Math.round(height * dpr);
  context.setTransform(dpr, 0, 0, dpr, 0, 0);
  motes = Array.from({ length: Math.round(Math.min(190, width * height / 11000)) }, makeMote);
}
function drawDust(time) {
  requestAnimationFrame(drawDust);
  if (!context || document.hidden) return;
  if (reducedMotion.matches) { context.clearRect(0, 0, width, height); return; }
  if (time - lastTick < 40) return;
  lastTick = time;
  context.clearRect(0, 0, width, height);
  for (const m of motes) {
    m.ph += m.sp;
    m.x += m.vx + Math.sin(m.ph) * .18;
    m.y += m.vy;
    m.life++;
    if (m.life > m.max || m.y < -8) Object.assign(m, makeMote());
    if (m.x < -8) m.x = width + 8;
    if (m.x > width + 8) m.x = -8;
    const p = m.life / m.max;
    const fade = Math.min(1, p / .22) * Math.min(1, (1 - p) / .3);
    const alpha = m.a * fade * (.65 + .35 * Math.sin(m.ph * 1.7));
    context.beginPath();
    context.arc(m.x, m.y, m.r, 0, Math.PI * 2);
    context.fillStyle = `rgba(236,244,238,${alpha})`;
    context.fill();
  }
}
window.addEventListener('resize', resizeDust);
resizeDust();
requestAnimationFrame(drawDust);

})();
